export default {
  slogan: 'Lets freelance together.',
  ctaTitle: 'Don’t just stand in the doorway , come on in!',
  ctaSubtitle:
    "There are sooo many perks to being part of Pigeons, whether you're a freelancer or a recruiter. But to get in on it, you've got to sign up first. (And yep, it's totally free!).",
  discoverButton: 'Discover Pigeons.',
  hero: {
    title: 'Find the perfect marketing freelancer for your project.',
    subtitle:
      'Connect with top marketing professionals, form powerful teams, and bring your projects to life.',
    getStarted: 'Get started.',
    browse: 'Browse freelancers.',
  },
  features: {
    title: 'Why Choose Us.',
    subtitle: 'Everything you need to find or offer marketing services.',
    smartMatching: {
      title: 'Smart Matching.',
      description:
        'Our AI-powered system matches you with the perfect freelancers based on your project needs.',
    },
    teamFormation: {
      title: 'Team Formation.',
      description:
        'Form powerful alliances with other freelancers to tackle larger projects efficiently.',
    },
    securePayments: {
      title: 'Secure Payments.',
      description: 'Enjoy secure payment processing and easy invoicing for all your projects.',
    },
  },
};
